// Stratia's social profiles, in ONE place: both footers (FooterV2 on every
// public page, SiteFooter on the pages that still carry it) read from here,
// and socialLinksDrift.test.js fails if any other file types one of these
// URLs. Founder, 2026-09-29: "the landing page should also point to facebook
// and instagram in the connect section underneath". Each URL answered 200 the
// same day. `cta` is the link's id in content/landingIds.js (and its Python
// twin), so the landing watch can count the clicks.
export const SOCIAL_LINKS = [
    { key: 'linkedin', name: 'LinkedIn', url: 'https://www.linkedin.com/company/stratia-admissions', cta: 'social_linkedin' },
    { key: 'facebook', name: 'Facebook', url: 'https://www.facebook.com/StratiaAdmissions', cta: 'social_facebook' },
    { key: 'instagram', name: 'Instagram', url: 'https://www.instagram.com/stratiaadmissions/', cta: 'social_instagram' },
    // The Channel, not a chat: followers get posts, nobody's number is shown
    // (founder set it up 2026-09-30; the URL answered 200 that day).
    { key: 'whatsapp', name: 'WhatsApp', url: 'https://whatsapp.com/channel/0029VbDjijt7T8bfuwHOdC31', cta: 'social_whatsapp' },
    // Founder, 2026-10-03: "everywhere we provide handles to all our
    // channels". Both answered 200 that day (YouTube channel
    // UCt14izfIvPaa6MiIvOG4_Hg; TikTok shows the Stratia Admissions profile).
    { key: 'youtube', name: 'YouTube', url: 'https://www.youtube.com/@stratiaadmissions', cta: 'social_youtube' },
    { key: 'tiktok', name: 'TikTok', url: 'https://www.tiktok.com/@stratiaadmissions', cta: 'social_tiktok' },
];

export const socialLabel = (s) => `Stratia Admissions on ${s.name}`;
